import { Action } from '@ngrx/store';

// @loyaltyDocs: Actions for getting account from Amadeus+Me

export const GET_ACCOUNT = '[Account] Get Agent Account';
export const GET_ACCOUNT_SUCCESS = '[Account] Get Agent Account Success';
export const GET_ACCOUNT_ERROR = '[Account] Get Agent Account Error';

// Actions for Getting Agent Account

// Calls on App initialization after getting configuration
// triggers request to Java Direct API to get account from
// Amadeus+Me
export class GetAccount implements Action {
  readonly type = GET_ACCOUNT;
  constructor() {}
}

export class GetAccountSuccess implements Action {
  readonly type = GET_ACCOUNT_SUCCESS;
  constructor(public payload: number) {}
}

export class GetAccountError implements Action {
  readonly type = GET_ACCOUNT_ERROR;
  constructor(public payload: string) {}
}

export type AccountActions = GetAccount | GetAccountSuccess | GetAccountError;
